import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AbstractService } from "./abstract-service.service";
import { Client } from "../Models/client";
import { APP_CONFIG, AppConfig } from "./config";
import { Response } from "../Models/response";
import { PasswordTO } from "../Models/PasswordTO";
import { Page } from "../Models/page";
import { Comment } from "../Models/comment";
import { HttpHeaders } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class ClientService extends AbstractService<Client, number> {
  url: string;

  constructor(http: HttpClient, @Inject(APP_CONFIG) config: AppConfig) {
    super(http);
    this.url = config.apiEndpoint.concat("/new/clients");
  }

  public getCurrent(): Observable<Client> {
    const url = `${this.url}/current`;

    return this.http.get<Client>(url, {
      withCredentials: true,
    });
  }

  public changeUsername(username: string): Observable<Response<Client>> {
    const url = `${this.url}/${username}`;
    return this.http.patch<Response<Client>>(url, "").pipe(
      map((response: Response<Client>) => {
        if (response.body) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }

  public changeEmail(
    email: string,
    token: string,
  ): Observable<Response<Client>> {
    const url = `${this.url}/${email}/${token}/email`;
    return this.http.patch<Response<Client>>(url, "").pipe(
      map((response: Response<Client>) => {
        if (response.body) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }

  public confirmationUpdateEmail(email: string): Observable<any> {
    const url = `${this.url}/${email}/confirmationEmailUpdate`;
    return this.http.post(url, "");
  }

  public checkPassword(id: number, password: string): Observable<boolean> {
    const url = `${this.url}/${id}/checkpassword`;
    return this.http.post<boolean>(url, password).pipe(
      map((response: boolean) => {
        if (response) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }

  public changePassword(passwordTO: PasswordTO): Observable<void> {
    const url = `${this.url}/password`;
    return this.http.patch<void>(url, passwordTO, { withCredentials: true });
  }

  public confirmSubscription(token: string): Observable<Response<Client>> {
    const url = `${this.url}/confirmation`;
    const params = new HttpParams().append("token", token);

    return this.http.get<Response<Client>>(url, { params }).pipe(
      map((response: Response<Client>) => {
        if (response.body) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }

  public getByProductIdPaged(
    id: number,
    page: number = 0,
    size: number = 5,
  ): Observable<Response<Page<Comment>>> {
    const options = {
      params: new HttpParams()
        .append("page", page.toString())
        .append("size", size.toString()),
    };
    const url = `${this.url}/product/${id}`;
    return this.http.get<Response<Page<Comment>>>(url, options);
  }

  public contactClientService(
    from: string,
    subject: string,
    question: string,
    firstName: string,
    lastName: string,
    phoneNumber: string,
  ): Observable<Response<Client>> {
    const url = `${this.url}/client-service`;

    const options = {
      params: new HttpParams()
        .append("from", from)
        .append("subject", subject)
        .append("question", question)
        .append("firstName", firstName)
        .append("lastName", lastName)
        .append("phoneNumber", phoneNumber),
    };

    return this.http.get<Response<Client>>(url, options).pipe(
      map((response: Response<Client>) => {
        if (response.body) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }

  // -----------------

  public getByUsername(username: string): Observable<Response<Client>> {
    const url = `${this.url}/${username}/username`;
    return this.http.get<Response<Client>>(url).pipe(
      map((response: Response<Client>) => {
        if (response.body) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }

  public changeInfo(client: Client): Observable<Response<Client>> {
    const url = `${this.url}`;
    return this.http.put<Response<Client>>(url, client).pipe(
      tap((response) => {
        console.log("RAW RESPONSE FROM API 👉", response);
      }),
      map((response: Response<Client>) => response),
    );
  }

  public searchClient(
    page = 0,
    size = 1,
    criteria: string,
  ): Observable<Response<Page<Client>>> {
    // const options = {
    let params = new HttpParams().set("criteria", criteria);
    //.set('page', page.toString())
    //  .set('size', size.toString())
    //   .set('criteria',criteria)
    // };
    const urlGetPaged = `${this.url}/search`;

    return this.http.get<Response<Page<Client>>>(urlGetPaged, { params }).pipe(
      map((response: Response<Page<Client>>) => {
        if (response.body) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }
  // service.ts

  // client.service.ts

  public resetPasswordRequest(email: string): Observable<any> {
    // 1. Définir l'URL de base (sans le paramètre email)
    const url = `${this.url}/reset-password-request`;

    // 2. Créer les paramètres de requête et y ajouter l'e-mail
    let params = new HttpParams();
    params = params.append("email", email); // Ceci crée "?email=..."

    // 3. Définir les Headers (vous pouvez les simplifier, mais c'est bien de les garder)
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    // 4. Effectuer la requête POST avec le corps vide et les paramètres d'URL
    return this.http.post(
      url,
      {}, // Corps de requête VIDE ou {}
      {
        headers: headers,
        params: params, // AJOUT des paramètres dans l'URL
        withCredentials: true,
      },
    );
  }

  public resetPassword(password: string, token: string) {
    const url = `${this.url}/reset-password`;
    return this.http.post<void>(url, { password, token });
  }

  public changeDefaultAddress(addressId: number) {
    const url = `${this.url}/default-address`;
    return this.http.post<Response<void>>(url, addressId).subscribe();
  }

  // public emailAddressExists(email: string): Observable<any> {
  //   const url = `${this.url}/email/${email}`;
  //   return this.http.get<Response<any>>(url).pipe(
  //     map((e) => {
  //       return e.body != null;
  //     }))
  // }
  public emailAddressExists(email: string) {
    const url = `${this.url}/email/${email}`;

    return this.http.get<Response<any>>(url).pipe(
      map((response: Response<any>) => {
        if (response.code === 0) {
          return response;
        }
        if (response.message === "entity.doesnt.exist") {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }
  /**
   * @description send the token visited by the user via the email confirmation link
   * @param {string} token ttoken in the link send to the user
   */
  confirmAccount(token: string): Observable<Client> {
    const param = new HttpParams().set("token", token);
    const url = `${this.url}/confirmation`;
    return this.http.get<Client>(url, { params: param });
  }
}
